<!-- Arquivo criado com referência https://github.com/unlayer/vue-email-editor/blob/master/src/components/EmailEditor.vue -->

<template>
  <div v-bind:id="id" class="unlayer-editor" v-bind:style="{ minHeight: unlayerConfig.minHeight }"></div>
</template>

<script>
import { loadScript } from '../boot/loadScript'
import unlayerConfig from '../constants/unlayerConfig'
import getFieldTypesAndCustomTypes from '../utils/fieldTypes'
import services from '@/services.js'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'EmailEditor',
  props: {
    minHeight: String,
    templateDesign: {
      type: Object,
      default: () => null,
    },
    templateName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editor: null,
      unlayerConfig: unlayerConfig(this),
      customTypes: [],
    }
  },
  computed: {
    organizationId() {
      return this.$route.params.organizationId
    },
    editorAppearance() {
      return this.$store.state.htmlBuilder.appearance
    },
    id() {
      return `email-editor-${this.organizationId}`
    },
    hasTemplateDesign() {
      return Boolean(this.templateDesign)
    },
    mergeTags() {
      if (this.customTypes.lenght == 0) return

      const mergeTags = {}
      this.customTypes.forEach((customType) => {
        const dynamicKey = customType.value

        mergeTags[dynamicKey] = {
          name: customType.personalizationTag,
          value: `[${customType.personalizationTag}]`,
        }
      })

      return mergeTags
    },
  },
  async mounted() {
    await loadScript(this.loadEditor.bind(this))

    if (this.hasTemplateDesign) {
      this.loadDesign(this.templateDesign)
    }
  },
  methods: {
    setIframeHeight() {
      // Esse método é um workaround para o problema do vue-email-editor v1 sem ele o iframe não respeita a altura passada como prop
      document.querySelector('iframe').style.minHeight = 'inherit'
    },
    loadEditor() {
      const options = this.unlayerConfig || {}

      if (this.editorAppearance) {
        options.appearance = this.editorAppearance
      }

      if (this.minHeight) {
        options.minHeight = this.minHeight
      }

      let organizationId = this.organizationId

      /* global unlayer */
      this.editor = unlayer.createEditor({
        ...options,
        id: this.id,
        displayMode: 'email',
        user: {
          id: organizationId,
        },
        locale: this.$store.getters.getLang,
      })

      this.editor.addEventListener('editor:ready', async () => {
        this.setIframeHeight()
        await this.setFieldTypes()
        this.editor.setMergeTags(this.mergeTags)
      })

      this.editor.addEventListener('design:updated', () => this.emitDesignUpdate())

      this.setCustomFileStorage()
    },
    emitDesignUpdate() {
      this.$emit('design:updated')
    },
    setCustomFileStorage() {
      this.editor.registerCallback('image', async (file, done) => {
        let originalFile = file.attachments[0]

        // * Garante MIME type correto para o arquivo
        const correctedFile = new File([originalFile], originalFile.name, { type: 'image/jpeg' })

        const data = new FormData()
        data.append('file', correctedFile)
        data.append('id', uuidv4())

        const organizationId = this.$route.params.organizationId
        const templateId = this.$route.params.templateId

        try {
          const response = await services.uploadImageHtmlBuilder(organizationId, templateId, data)

          if (response.status >= 200 && response.status < 300) {
            done({ progress: 100, url: response.data.data.url })
          } else {
            throw new Error(response.statusText)
          }
        } catch (error) {
          console.error('Error uploading image:', error)
        }
      })
    },
    async setFieldTypes() {
      const organizationId = this.$route.params.organizationId
      this.customTypes = await getFieldTypesAndCustomTypes(organizationId)
    },
    loadDesign(design) {
      this.editor.loadDesign(design)
    },
    getHtmlContent() {
      return new Promise((resolve) => {
        this.editor.exportHtml((data) => {
          resolve(data)
        })
      })
    },
  },
  watch: {
    templateDesign() {
      this.loadDesign(this.templateDesign)
      this.emitDesignUpdate()
    },
  },
}
</script>

<style scoped>
.unlayer-editor {
  flex: 1;
  display: flex;
}
</style>
